import React from 'react';
import { FormGroup } from '../../atoms/form-group/form-group';
import { FormRow } from '../../atoms/form-row/form-row.atom';
import {
  StripeCardInput,
  StripeElementRef,
} from '../../atoms/stripe-inputs/stripe-card-input/stripe-card-input';
import { StripeExpiryInput } from '../../atoms/stripe-inputs/stripe-expiry-input/stripe-expiry-input.atom';
import { StripeCvcInput } from '../../atoms/stripe-inputs/stripe-cvc-input/stripe-cvc-input.atom';
import { useTranslation } from 'react-i18next';
import { FormDataShape } from '../../../common/hooks/useCheckoutController/useCheckoutController.types';
import { LabelV2 } from '../../atoms/v2/label/label-v2.atom';
import { InputV2 } from '../../atoms/v2/input/input-v2.atom';
import { documentMasks } from '../../../common/utils/document-masks';
import { InputField } from '../input-field/input-field.molecule';
import { Checkout } from '../../../common/types/checkout';

type Props = {
  checkout: Checkout;
  data: FormDataShape;
  onChange: (field: keyof FormDataShape, value: string) => void;
  numberRef: React.RefObject<StripeElementRef>;
  expiryRef: React.RefObject<StripeElementRef>;
  cvcRef: React.RefObject<StripeElementRef>;
  handleStripeChange: (
    field: 'number' | 'expiry' | 'cvc',
    s: { complete: boolean; error: string | null },
  ) => void;
};

export const StripeCardSection: React.FC<Props> = ({
  data,
  onChange,
  numberRef,
  expiryRef,
  cvcRef,
  handleStripeChange,
  checkout,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <FormRow>
        <FormGroup>
          <LabelV2 htmlFor="stripe-card-number">{t('cardNumber')}</LabelV2>
          <StripeCardInput
            color={
              checkout?.checkoutConfig?.config?.checkoutData?.purchaseButton
                ?.background
            }
            onStripeChange={handleStripeChange}
            ref={numberRef}
          />
        </FormGroup>
      </FormRow>

      <FormRow>
        <FormGroup>
          <LabelV2 htmlFor="cardName">{t('cardName')}</LabelV2>
          <InputV2
            color={
              checkout?.checkoutConfig?.config?.checkoutData?.purchaseButton
                ?.background
            }
            id="cardName"
            type="text"
            value={data.cardName}
            onChange={(e) => onChange('cardName', e.target.value)}
            placeholder={t('cardNamePlaceholder')}
            data-hj-suppress
          />
        </FormGroup>
      </FormRow>

      <FormRow>
        <FormGroup>
          <LabelV2 htmlFor="stripe-expiry">{t('expiryDate')}</LabelV2>
          <StripeExpiryInput
            color={
              checkout?.checkoutConfig?.config?.checkoutData?.purchaseButton
                ?.background
            }
            onStripeChange={handleStripeChange}
            ref={expiryRef}
          />
        </FormGroup>
        <FormGroup>
          <LabelV2 htmlFor="stripe-cvc">CVV</LabelV2>
          <StripeCvcInput
            color={
              checkout?.checkoutConfig?.config?.checkoutData?.purchaseButton
                ?.background
            }
            onStripeChange={handleStripeChange}
            ref={cvcRef}
          />
        </FormGroup>
      </FormRow>

      <FormRow>
        <InputField
          color={
            checkout?.checkoutConfig?.config?.checkoutData?.purchaseButton
              ?.background
          }
          id="cpf"
          label={t('document')}
          placeholder={t('fillYourDocument')}
          mask={documentMasks[checkout?.paisEnum]}
          maskChar=""
          value={data.cpf}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onChange('cpf', e.target.value)
          }
          suppressAnalytics={true}
        />
      </FormRow>
    </>
  );
};
